import { LatLng, LatLngBounds } from 'leaflet';
import { PlaceList } from '../models/factories/PlaceFactory';
import { StoryList } from '../models/factories/StoryFactory';
import { TrailList } from '../models/factories/TrailFactory';
import React from 'react';
import { ActivityList } from '../models/factories/ActivityFactory';
import { TopicList } from '../models/factories/TopicFactory';

export enum ListTypeIdentifiers {
	PLACE,
	TRAIL,
	STORY,
}

export interface IList {
	places?: PlaceList;
	stories?: StoryList;
	trails?: TrailList;
}

export interface IGenericList {
	type: ListTypeIdentifiers;
	data: IList;
}

export type ExplorerAppDataProps = {
	current_location: LatLng;
	boundary: LatLngBounds;

	features?: {
		all_places?: PlaceList;
		all_stories?: StoryList;
		all_trails?: TrailList;
		all_activities?: ActivityList;
		all_topics?: TopicList;
	};
};

// TODO : Get Proper Bounds (& outline GPX?) from Sarah
export const Default_Bounds = new LatLngBounds([
	[0, 0],
	[0, 0],
]);

export const Default_LatLng = new LatLng(0, 0);

export const AONB_Bounds = new LatLngBounds([
	[54.997371, -2.7805],
	[54.510865, -1.733303],
]);

export const ExplorerAppData: ExplorerAppDataProps = {
	current_location: AONB_Bounds.getCenter(),
	boundary: AONB_Bounds,
};

export const ExplorerContext = React.createContext(ExplorerAppData);
